import gql from 'graphql-tag';



export const add = gql`mutation CreateCountry($country: CountryInput!) {
    createCountry(country: $country) {
        id
        name
        isoCode
    }
}`;

export const edit = gql`mutation EditCountry($id: ID!, $country: CountryInput!) {
    editCountry(id: $id, country: $country) {
        id
        name
        isoCode
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/country.js